/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from "styled-components";
import Colors from "constants/Colors";

import { Text } from "components/Text";
import Label from 'components/Form/Label';
import { Breakpoints } from "constants/Breakpoints";
import { mediaHelper } from "../../../../utils/src";
import { mediaHelperMaxWidth } from "../../../../utils/src";

export const FieldText = styled(Text)`
  font-size: ${(props) => (props.size ? `${props.size}px` : "14px")};
  font-weight: ${(props) => (props.bold ? `bold` : "normal")};
  color: #53565a;
  display: block;
  padding: 3px 0;
`;

export const Content = styled.div`
  background-color: ${Colors.WHITE};
  border: 1px solid ${Colors.BLUE};
  margin: 0;
  border-radius: 10px;
  box-shadow: 0px 17px 17px 6px #5f5f5f1a;

  @media screen and (min-width: ${Breakpoints.sm}) {
    margin-top: 40px;
    margin-bottom: 10%;
    border-radius: 15px;
  }

  ${mediaHelper.md`
    border-radius: 20px;
  `}
`;

export const LoadContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 28px;
`;

export const Line = styled.div`
  width: 100%;
  height: 2px;
  margin: 5px 0;
  background-color: ${Colors.GRAY[4]};
`;

export const InlineLabel = styled(Text)`
  display: inline-block;
  width: 30%;
  vertical-align: middle;
  padding-right: 5px;
  justify-content: start;
  align-items: flex-start;
  justify-self: flex-start;
  text-align: left;
  font-size: 13px;
  color: ${Colors.GRAY[3]};

  @media screen and (min-width: 601px) {
    display: none;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  padding: 0;
  width: 100%;
`;

export const TableHead = styled.thead`
  @media screen and (max-width: 600px) {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
`;

export const TableBody = styled.tbody`
  tr {
    border-bottom: 2px solid #e0e0e0;
  }
`;

export const TableColumn = styled.td`
${({ right }) => right ? 'text-align: right !important' : 'text-align: left'}
  vertical-align: top;
  text-align: left;
  padding-bottom: 8px;
  padding-top: 8px;
  padding-right: 5px;
  display: table=cell;

  &:last-child {
    padding-right: 0px;
  }

  @media screen and (max-width: ${Breakpoints.sm}) {
    display: flex;
    max-width: unset !important;
    padding-top: 0px;
    padding-bottom: 2px;

    &:last-child {
      padding-bottom: 10px;
    }

    &:first-child {
      padding-top: 10px;
    }
  }
`;

export const TableHeader = styled.th`
  ${({ minWidth }) => (minWidth ? `min-width: ${minWidth}px` : "")}
  ${({ maxWidth }) => (maxWidth ? `width: ${maxWidth}px` : "")}
  position: relative;
  vertical-align: top;
  padding: 5px;
  padding-left: 0px;
  text-align: left;
  span {
    font-size: 13px !important;
  }

  ${({ right }) => right ? 'text-align: right !important' : 'text-align: left'}

  &:last-child {
    text-align: right;
  }
`;

export const LabelEdit = styled(Label)`

  @media screen and (max-width: ${Breakpoints.sm}) {
    width: unset;
    text-align: center;
  } 
  
`;

export const RowFilterIcon = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: end;
  flex-direction: row;
  background-color: ${Colors.BLUE};
  border-radius: 20px 20px 0 0;
  margin-bottom: 10px;
  padding: 7px 10px;
  position: relative;

  @media (max-width: ${Breakpoints.md}) {
    border-radius: 10px 10px 0 0;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
  width: 100%;
  padding: 0px 20px 0px 0px;

  ${mediaHelperMaxWidth.sm`
    flex-direction: column;
    align-items: center;
  `}
`;

export const ButtonContent = styled.div`
  display: flex;
  flex-direction: auto;
  justify-content: space-evenly;
  background-color: #fff;

  ${mediaHelperMaxWidth.sm`
    margin-top: 10px;
    width: 100%
  `}
`;

export const ViewText = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
  
  
  ${mediaHelperMaxWidth.md`
      justify-content: flex-start;
  `}
`;